import * as React from 'react';
import { forwardRef } from 'react';

export type DMInputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const DMInput = forwardRef<HTMLInputElement, DMInputProps>(
  ({ className = '', ...props }, ref) => {
    return <input ref={ref} className={className} {...props} />;
  }
);
DMInput.displayName = 'DMInput';
